export default {
    title: 'dark',
    background: {
        primary: '#202C36',
        secundary: '#2B3844',
    },
    'text-colors': {
        primary: '#FFFFFF',
        secundary: '#FFFFFF',
    },
};
